module.exports = __webpack_public_path__ + "img/twotit.80c13969.png";